import { BankList } from './bank.model';
import { SelectData } from './select-input.model';

export interface Account {
  nmrAgencia: number;
  nmrConta: number;
  descricao: string;
  banco: BankList[];
}

export interface AssignorCreationAccount {
  id: number;
  numeroAgencia: number;
  numeroConta: number;
  descricao: string;
  contaAtivado: boolean;
  isPadrao: boolean;
  digitoConta: string;
  digitoAg: string;
}

export interface AssignorFormAccount extends AssignorCreationAccount {
  banco: SelectData;
}

export interface AssignorRequestAccount extends AssignorCreationAccount {
  banco: BankFormCedente;
}

export interface BankFormCedente {
  idBanco?: number;
  nomeBanco: string;
  codigoBancario: number;
}
